export default {
  company_name: 'AIX JAPAN Co., Ltd.',
  locale: 'en_US',
  nav_philosophy: 'Philosophy',
  nav_service: 'Services',
  nav_cases: 'Case Studies',
  nav_company: 'Company',
  nav_member: 'Team',
  nav_recruit: 'Careers',
  nav_news: 'News',
  nav_contact: 'Contact',
  nav_menu_toggle: 'Menu',
  flow_activities_label: 'What we do',
  flow_duration_label: 'Duration',
  flow_deliverables_label: 'Deliverables',
  flow_client_asks_label: 'What we ask of you',
  nf_meta_title: '404 Not Found | AIX JAPAN',
  nf_title: 'Page not found',
  nf_desc: 'The URL may have changed or the page may no longer exist.',
  nf_back: 'Back to Home',
  cta_contact: 'Contact Us',
  cta_contact_sub: 'CONTACT',
  cta_recruit: 'Careers',
  cta_recruit_sub: 'RECRUIT',
  footer_services: 'SERVICES',
  footer_company: 'COMPANY',
  footer_more: 'MORE',
  footer_faq: 'FAQ',
  footer_privacy: 'Privacy Policy',
  footer_security: 'Security Policy',
  footer_copyright: '© AIX JAPAN Co., Ltd. All Rights Reserved.',
  footer_page_top: 'PAGE TOP',
  footer_description: 'Combining AI with every field to drive\ncorporate transformation and growth\nthrough end-to-end consulting.',
  footer_cta_text: 'For AI-related challenges, strategy planning,\nor talent shortages, please feel free\nto contact us anytime.',
  service_sd: 'AIX Consulting',
  service_sdx: 'AIX Manager',
  service_se: 'AIX Training',
  service_ai_tool: 'GenAI All In One Tool',
  cta_band_title: 'Tell Us About Your Challenges',
  cta_band_text: 'We support AI adoption that takes root in the field, regardless of industry or company size.\nFeel free to start with a conversation about organizing your challenges.',
  cta_band_button: 'Contact Us',
  lang_ja: 'JA',
  lang_en: 'EN',
};